module.exports = "/images/vendor/vue-paycard/src/21.jpg?582b55ee27e888cc559cf1722665dd46";